export default __webpack_public_path__ + "static/media/section1-measure3.8ccedc77.svg";